var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video",
      class: _vm.getVariant("video"),
      style: _vm.getStyle
    },
    [
      _c("div", {
        staticClass: "video__placeholder",
        class: { "video__placeholder--is-loading": _vm.ready }
      }),
      _c(
        "div",
        { staticClass: "video__wrapper" },
        [_vm._t("default", null, { onplay: _vm.playing() })],
        2
      ),
      _c("div", { staticClass: "video__title" }, [
        _c(
          "h1",
          {
            directives: [
              {
                name: "inview",
                rawName: "v-inview:class",
                value: ["animate"],
                expression: "['animate']",
                arg: "class"
              }
            ],
            staticClass: "video__title__line"
          },
          [_vm._t("title-first")],
          2
        ),
        _c(
          "h2",
          {
            directives: [
              {
                name: "inview",
                rawName: "v-inview:class",
                value: ["animate"],
                expression: "['animate']",
                arg: "class"
              }
            ],
            staticClass: "video__title__line"
          },
          [_vm._t("title-second")],
          2
        )
      ]),
      _c(
        "div",
        {
          staticClass: "video__icon video__icon--left",
          class: { "video__icon--center": !_vm.hasFullscreen }
        },
        [
          _c("icon-scroll-view", {
            directives: [
              {
                name: "inview",
                rawName: "v-inview:class",
                value: ["animate"],
                expression: "['animate']",
                arg: "class"
              }
            ]
          })
        ],
        1
      ),
      _vm.hasFullscreen
        ? _c(
            "div",
            { staticClass: "video__icon video__icon--right" },
            [
              _c("icon-play-view", {
                directives: [
                  {
                    name: "inview",
                    rawName: "v-inview:class",
                    value: ["animate"],
                    expression: "['animate']",
                    arg: "class"
                  }
                ],
                attrs: { immediate: true, loading: _vm.loading },
                on: { click: _vm.clickFullscreen }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._m(0),
      _vm.hasFullscreen
        ? _c("video-fullscreen-view", {
            attrs: { "video-id": _vm.videoId, fullscreen: _vm.fullscreen },
            on: {
              "close-fullscreen": function($event) {
                _vm.fullscreen = false
              },
              "click-esc": function($event) {
                _vm.fullscreen = false
              },
              "stop-loading": function($event) {
                _vm.loading = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "video__icon video__icon--bottom" }, [
      _c("i", { staticClass: "icon-arrow animation-jump" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a9bf54a", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a9bf54a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/video-view.vue
// module id = 280
// module chunks = 22 66